// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1huNM","clinicsSelect":"TableHeading_clinicsSelect__3j-CB"};